module.exports = __webpack_public_path__ + "static/media/OktaSquare.82147280.svg";